import type { PosSaleLine } from '../types';

const SERVICE_TYPES = new Set(['service']);

export const isServiceLine = (line: PosSaleLine): boolean => {
  return SERVICE_TYPES.has(line.item.item_type);
};

export const deriveIsPrepaid = (line: PosSaleLine): boolean => {
  if (!isServiceLine(line)) {
    return false;
  }

  if (typeof line.flags?.isPrepaid === 'boolean') {
    return line.flags.isPrepaid;
  }

  const serviceDetail = line.item.service_detail;
  if (!serviceDetail) {
    return false;
  }

  if (serviceDetail.is_subscription) {
    return true;
  }

  if (serviceDetail.history_enabled) {
    return true;
  }

  return false;
};

export const hasPendingProfessional = (line: PosSaleLine): boolean => {
  if (!isServiceLine(line)) {
    return false;
  }

  if (line.professionalId != null) {
    return false;
  }

  if (line.flags?.hasPendingProfessional) {
    return true;
  }

  const serviceDetail = line.item.service_detail;
  if (serviceDetail?.default_professional_id != null) {
    return false;
  }

  return true;
};
